export const styles = (settings) => {
  return {
    sx: [
      {
        fontSize: 16,
        fontFamily: 'Titillium Web',
        borderWidth: 0,
      },
      {
        '.MuiDataGrid-columnHeaderTitle': {
          fontWeight: 600,
          whiteSpace: 'normal',
          textAlign: 'center',
        },
        '.MuiDataGrid-main': {
          borderRadius: '12px',
          padding: '10px 0px 30px',
          boxShadow: '0px 8px 12px 0px #ADADAD3D',
        },
        '.MuiDataGrid-footerContainer': {
          border: 'none',
          marginTop: '20px',
        },
        '.MuiSvgIcon-root': {
          width: 24,
          height: 24,
        },
        '.MuiButtonBase-root.MuiPaginationItem-root': {
          fontSize: 11,
          fontFamily: 'Titillium Web',
          fontWeight: 700,
          color: '#ABC0D8',
          borderColor: '#ABC0D8',
        },
        '.MuiPaginationItem-root.MuiPaginationItem-previousNext': {
          backgroundColor: settings?.bg ? settings.bg : 'var(--color-primary-blue)',
          color: settings?.textColor ? settings.textColor : '#fff',
          padding: '0 20px',
          border: 'none',
          boxShadow: '0px 6px 10px 0px #6690FF4D',
        },
        '.MuiPaginationItem-root.Mui-selected': {
          backgroundColor: settings?.bg ? settings.bg : 'var(--color-primary-blue) !important',
          color: settings?.textColor ? settings.textColor : '#fff',
          border: 'none',
          boxShadow: '0px 6px 10px 0px #6690FF4D',
        },
        '.MuiDataGrid-cell:focus-within': {
          outline: 'none',
        },
        '.MuiDataGrid-columnHeader:focus': {
          outline: 'none',
        },
        '.MuiDataGrid-columnHeader:focus-within': {
          outline: 'none',
        },
        '.MuiPagination-ul>li': {
          marginLeft: '6px',
        },
        '.MuiDataGrid-row': {
          padding: '0 20px',
        },
        '.MuiDataGrid-columnHeaders': {
          padding: '0 20px',
        },
        '.MuiDataGrid-cell': {
          width: '100% !important',
          minWidth: 'auto !important',
        },
        '.MuiDataGrid-columnHeader': {
          width: '100% !important',
          minWidth: 'auto !important',
        },
      },
    ],
  };
};
